module.exports = __webpack_public_path__ + "static/media/Arrow_DownWords.2a1ed36b.svg";